// Lib
import React from 'react';
import { Check } from 'lucide-react';

// Components
import { IndustrySelector } from '../components/IndustrySelector';
import { Input } from '@components/ui/input';
import { cn } from '@components/lib/utils';

// Types
import type {
  OrganizationAnswers,
  OrganizationErrors,
} from '../../model/useCreateOrganization';

interface IndustryStepProps {
  answers: OrganizationAnswers;
  error: OrganizationErrors;
  onChange: (name: string, value: string) => void;
}

export const IndustryStep: React.FC<IndustryStepProps> = ({
  answers,
  error,
  onChange,
}) => {
  const ownActive = Boolean(answers?.industryOwn);

  return (
    <>
      <h1 className="mb-8 text-center text-2xl font-bold tracking-tight text-foreground">
        What is your industry?
      </h1>
      <IndustrySelector onChange={onChange} answers={answers} />
      <div className="relative w-full">
        {ownActive && (
          <div className="absolute -right-1 -top-1 z-[1] flex size-4 items-center justify-center rounded-full bg-marble-blue-400">
            <Check className="size-3 text-white" />
          </div>
        )}
        <Input
          type="text"
          name="industryOwn"
          placeholder="Enter your own"
          aria-invalid={Boolean(error?.industryOwn)}
          className={cn(
            ownActive && 'border-marble-blue-400 bg-marble-blue-50',
          )}
          onChange={(field) => {
            if (answers?.industry) onChange('industry', '');
            onChange('industryOwn', field.target.value);
          }}
          value={answers?.industryOwn}
        />
        {error?.industryOwn && (
          <p className="mt-1 text-xs text-marble-red-500">
            {error.industryOwn}
          </p>
        )}
      </div>
    </>
  );
};
